const PageStrings = {
  CONTRIBUTE_TRAIL: 'CONTRIBUTE_TRAIL',
  EXPLORE_ALL_PAGE: 'EXPLORE_ALL',
  EXPLORE_FAVORITE_PAGE: 'EXPLORE_FAVORITE',
  EXPLORE_COMPLETED_PAGE: 'EXPLORE_COMPLETED',
  EXPLORE_CUSTOM_PAGE: 'EXPLORE_CUSTOM',
  EXPLORE_TRAIL_MAP_PAGE: 'EXPLORE_TRAIL_MAP',
  EXPLORE_USERS_TRACKS_PAGE: 'EXPLORE_USERS_TRACKS',
  EXPLORE_LIFELINE_PAGE: 'EXPLORE_LIFELINE',
  EXPLORE_USERS_TRACKS_MAP_PAGE: 'EXPLORE_USERS_TRACKS_MAP',
  EXPLORE_USERS_MAPS_PAGE: 'EXPLORE_USERS_MAPS',
  EXPLORE_USERS_MAPS_MAP_PAGE: 'EXPLORE_USERS_MAPS_MAP',
  EXPLORE_COMMUNITY_CONTENT_PAGE: 'EXPLORE_COMMUNITY_CONTENT',
  ET_PHOTO_USER_SLUG: 'alltrails-user',
  SEO_PAGE: 'SEO_PAGE'
};

const isSingleMapPage = page => {
  return [
    PageStrings.EXPLORE_TRAIL_MAP_PAGE,
    PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE,
    PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE,
    PageStrings.EXPLORE_LIFELINE_PAGE
  ].includes(page);
};

const isAtMapPage = page => {
  return [PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE, PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE].includes(page);
};

const isAtMapCollectionPage = page => {
  return [PageStrings.EXPLORE_USERS_TRACKS_PAGE, PageStrings.EXPLORE_USERS_MAPS_PAGE].includes(page);
};

const isListPage = page => {
  return [PageStrings.EXPLORE_FAVORITE_PAGE, PageStrings.EXPLORE_COMPLETED_PAGE, PageStrings.EXPLORE_CUSTOM_PAGE].includes(page);
};

export { PageStrings, isSingleMapPage, isAtMapPage, isAtMapCollectionPage, isListPage };
